import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UliDetailsPreviewModel, UliDetailsPreviewStateModel } from '../models/uli-details.model';
import { UliDetailsInitialState, UliDetailsLoad } from './uli-details.actions';
import { UliDetailsService } from './uli-details.service';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { HubBrief, HubContextFacade } from '../../../../administration';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

const initialState: UliDetailsPreviewStateModel = {
  data: null,
  loaded: false,
};

@State<UliDetailsPreviewStateModel>({
  name: 'uliDetails',
  defaults: initialState,
})
@Injectable()
export class UliDetailsState {
  @Selector()
  static getState(state: UliDetailsPreviewStateModel): UliDetailsPreviewStateModel {
    return state;
  }

  @Selector()
  static getData(state: UliDetailsPreviewStateModel): UliDetailsPreviewModel {
    return state.data;
  }

  @Selector()
  static getLoaded(state: UliDetailsPreviewStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private uliDetailsService: UliDetailsService,
    private notificationService: NotificationService,
    private hubContextFacade: HubContextFacade,
  ) {}

  @Action(UliDetailsInitialState)
  setInitialState(ctx: StateContext<UliDetailsPreviewStateModel>): void {
    ctx.setState(initialState);
  }

  @Action(UliDetailsLoad)
  getUliDetails(
    ctx: StateContext<UliDetailsPreviewStateModel>,
    { payload }: UliDetailsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.hubContextFacade.selectedHub$.pipe(
      filter(Boolean),
      map((hub: HubBrief) => hub.id),
      switchMap((hubId: number) => this.uliDetailsService.getUliDetails(payload, hubId)),
      take(1),
      map((respone: UliDetailsPreviewModel) => {
        ctx.patchState({
          data: respone,
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }
}
